var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2Charts1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-00b3bc33-5a18-4f7b-8d1f-11c07d3f9533",
    "data-name": "uuid-19411655-b243-48fc-88e4-52154d1b1363",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "pie1-pie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.31,240.9l-48.21-141.48",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m298.31,240.9l-147.74-8.77",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.31,240.9l138.98,45.7",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.75,370.4c72.54-14.76,119.39-85.53,104.63-158.08-14.76-72.54-85.53-119.39-158.08-104.63h0c-72.54,14.76-119.39,85.53-104.63,158.08,14.76,72.54,85.53,119.39,158.08,104.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.75,370.4c72.54-14.76,119.39-85.53,104.63-158.08-14.76-72.54-85.53-119.39-158.08-104.63h0c-72.54,14.76-119.39,85.53-104.63,158.08,14.76,72.54,85.53,119.39,158.08,104.63Z",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.03,239.04l-27.38-118.59c8.98-2.06,18.16-3.1,27.38-3.12v121.71Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.03,239.04l-51.44-110.3c7.69-3.65,15.75-6.43,24.06-8.28l27.38,118.58Z",
    style: {
      fill: "#034e62",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.03,239.04l-66.29,102.07c-56.37-36.61-72.39-111.98-35.79-168.36h0c13.07-20.12,28.89-33.88,50.64-44.01l51.44,110.3h0Z",
    style: {
      fill: "#00b2b8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.03,239.04v-121.71c67.21,0,121.7,54.48,121.71,121.69h0c0,67.22-54.48,121.71-121.69,121.72h-.01c-25,0-45.31-6.02-66.29-19.63l66.29-102.07h0Z",
    style: {
      fill: "#ffd239",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.7,286.59c26.26-5.34,43.21-30.96,37.87-57.22h0c-5.34-26.26-30.96-43.21-57.22-37.87h0c-26.26,5.34-43.21,30.96-37.87,57.22s30.96,43.21,57.22,37.87h0",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.56,276.08c20.45-4.16,33.66-24.12,29.5-44.57h0c-4.16-20.45-24.11-33.66-44.57-29.5-20.45,4.16-33.66,24.11-29.5,44.57h0c4.16,20.45,24.11,33.66,44.57,29.5Z",
    style: {
      fill: "none",
      stroke: "#00b2b8",
      strokeWidth: "1.1px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie1-label1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.2,214.06v21h-2.25v-16.8h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85h1.65Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.35,229.21c0,3.15-2.7,6.15-7.05,6.15-4.8,0-7.05-3.15-7.05-3.15l1.5-1.5s1.8,2.55,5.55,2.55c3.15,0,4.95-1.8,4.95-4.05,0-2.13-1.89-4.05-4.95-4.05h-2.1v-2.1h2.1c2.55,0,4.05-1.5,4.05-3.75,0-1.95-1.5-3.45-4.05-3.45-3.15,0-4.8,2.4-4.8,2.4l-1.5-1.65s2.1-2.85,6.3-2.85c3.75,0,6.3,2.55,6.3,5.55,0,3.6-3.15,4.65-3.15,4.65,0,0,3.9.9,3.9,5.25h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.15,219.31c0,3.15-2.7,4.35-2.7,4.35,0,0,3.6,1.35,3.6,5.25,0,3.45-3,6.45-7.05,6.45s-7.05-3-7.05-6.45c0-3.9,3.6-5.25,3.6-5.25,0,0-2.7-1.2-2.7-4.35,0-2.85,2.7-5.55,6.15-5.55s6.15,2.7,6.15,5.55Zm-10.95,9.6c0,2.25,1.8,4.35,4.8,4.35s4.8-2.1,4.8-4.35-2.1-4.35-4.8-4.35-4.8,2.1-4.8,4.35Zm8.7-9.6c0-1.95-1.5-3.45-3.9-3.45s-3.9,1.5-3.9,3.45,1.5,3.45,3.9,3.45,3.9-1.5,3.9-3.45Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.65,233.56l-3.45,5.4-1.35-.75,2.7-5.85,2.1,1.2h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.65,228.46c0,4.05-2.85,6.9-7.2,6.9-4.65,0-6.9-3.15-6.9-3.15l1.5-1.5s1.8,2.55,5.4,2.55c3,0,4.95-1.95,4.95-4.8s-1.95-4.8-4.8-4.8c-3.18,0-4.65,2.25-4.65,2.25h-1.65l.75-11.85h11.25v2.1h-9.3l-.45,6.6s1.5-1.2,4.05-1.2c4.05,0,7.05,3,7.05,6.9Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.1,229.06l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.4,226.06v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3h7.35Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.56,242.45c1.14,0,3.18.48,3.18,1.83v.83h-1.1v-.48c0-.71-1.2-1.07-2.05-1.07-1.7,0-3.02,1.28-3.02,3.19s1.33,3.32,3.06,3.32,2.67-1.15,2.67-1.15l.65.86s-1.2,1.42-3.33,1.42c-2.53,0-4.29-1.95-4.29-4.45s1.82-4.31,4.25-4.31h-.02,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.01,244.85c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.79,245.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.02,246.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.17,249.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.79,247.28h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h.01Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.29,245.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.52,246.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.44,244.85c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.17,246.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.58,249.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.84,247.68l1.97-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46Zm4.38-2.47h1.16l-1.97,2.47,1.97,2.46h-1.16l-1.97-2.46,1.97-2.47Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.38,246.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.18-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.71,247.28h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.13,243.85c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.45,247.28h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.07,244.85c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.72,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.22,246.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.92,244.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130,247.68l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Zm2.42,0l-1.97-2.47h1.16l1.97,2.47-1.97,2.46h-1.16l1.97-2.46Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie1-label2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m117,48.06v21.01h-1.49v-18.3c-.1.12-.24.27-.42.45s-.62.43-1.33.73c-.7.31-1.47.46-2.31.46v-1.2c.84,0,1.63-.26,2.36-.79s1.25-1.05,1.54-1.57l.45-.79s1.2,0,1.2,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.95,58.08c.19.06.54.22,1.04.48s.95.57,1.34.93.74.89,1.05,1.57.46,1.45.46,2.29c0,1.6-.65,3-1.96,4.2s-2.95,1.79-4.94,1.79c-.84,0-1.64-.11-2.4-.33s-1.39-.48-1.88-.78-.92-.6-1.29-.92-.63-.58-.79-.79l-.25-.34,1.05-1.04c.04.08.11.18.21.3s.32.34.66.64.71.58,1.11.82.92.45,1.56.64,1.31.29,2.01.29c1.6,0,2.9-.44,3.9-1.32s1.5-1.94,1.5-3.18-.5-2.3-1.5-3.18-2.3-1.32-3.9-1.32h-1.95v-1.51h1.95c1.4,0,2.52-.4,3.37-1.19s1.27-1.79,1.27-3c0-1.08-.43-2.01-1.29-2.77s-1.98-1.14-3.35-1.14c-.96,0-1.85.2-2.67.6s-1.41.8-1.77,1.2l-.51.6-1.05-1.2c.06-.08.14-.18.26-.3s.36-.34.74-.64.79-.58,1.22-.82.99-.45,1.68-.64,1.39-.29,2.12-.29c1.76,0,3.22.53,4.4,1.6s1.76,2.34,1.76,3.8c0,.72-.12,1.38-.37,1.98s-.55,1.06-.9,1.39-.7.61-1.05.84-.64.38-.88.46l-.4.12c.12.02.27.06.46.12l-.02.04h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.67,67.86l-3.15,4.95-.89-.45,2.55-5.39,1.49.89h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.12,48.06v1.51l-9.61,19.5h-1.49l9.59-19.5h-11.4v-1.51h12.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.59,67.55c-1.29-1.21-1.93-2.65-1.93-4.33,0-.78.14-1.51.42-2.18s.61-1.2,1-1.6.79-.74,1.19-1.03.74-.47,1.03-.57l.42-.18c-.08-.02-.19-.07-.33-.14s-.4-.23-.77-.47c-.37-.24-.69-.51-.96-.82s-.52-.74-.75-1.29-.34-1.15-.34-1.78c0-1.44.57-2.7,1.71-3.78s2.52-1.63,4.14-1.63,3,.54,4.14,1.62c1.14,1.08,1.71,2.34,1.71,3.79,0,.64-.11,1.24-.33,1.79s-.48.98-.79,1.3-.61.59-.92.81-.56.38-.78.49l-.34.12c.1.04.24.1.43.18s.52.27.98.57.87.64,1.23,1.03.68.91.97,1.59.44,1.41.44,2.19c0,1.68-.64,3.12-1.93,4.33s-2.9,1.81-4.82,1.81-3.53-.6-4.82-1.81h0Zm8.6-1.03c.98-.9,1.46-2,1.46-3.3s-.51-2.42-1.52-3.38c-1.01-.95-2.26-1.43-3.74-1.43s-2.72.48-3.73,1.43-1.51,2.08-1.51,3.38.49,2.4,1.46,3.3,2.24,1.35,3.78,1.35,2.8-.45,3.78-1.35h.02,0Zm-.66-10.66c.82-.71,1.23-1.61,1.23-2.69s-.41-2-1.23-2.76-1.86-1.14-3.12-1.14-2.3.38-3.12,1.14-1.23,1.68-1.23,2.76.41,1.98,1.23,2.69,1.86,1.07,3.12,1.07,2.3-.36,3.12-1.07Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.44,50.91v18.15h-1.51v-21.01h1.2l9.3,12.3,9.3-12.3h1.2v21.01h-1.51v-18.15l-8.99,12s-8.99-12-8.99-12Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.58,55.41v1.35h-7.79c-.1.6-.15,1.2-.15,1.8l.15,1.8h7.79v1.35h-7.5c.24,1.44,1.14,2.82,2.69,4.15s3.25,2,5.12,2c1.12,0,2.19-.24,3.21-.72s1.76-.96,2.23-1.44l.72-.69,1.04,1.04c-.08.08-.19.19-.33.34s-.45.42-.92.8-.96.71-1.48,1-1.18.55-1.99.79-1.64.36-2.48.36c-2.22,0-4.23-.78-6.03-2.34s-2.94-3.33-3.42-5.31h-3v-1.35h2.84c-.1-.6-.15-1.2-.15-1.8l.15-1.8h-2.84v-1.35h3c.48-1.98,1.62-3.75,3.42-5.31s3.81-2.34,6.03-2.34c.84,0,1.66.11,2.46.34s1.47.51,2.02.83,1.04.64,1.46.96.75.59.95.81l.29.35-1.04,1.05c-.06-.08-.15-.18-.29-.32s-.4-.36-.81-.67-.83-.6-1.27-.86-1-.49-1.69-.7-1.38-.31-2.09-.31c-1.86,0-3.56.67-5.11,2s-2.45,2.72-2.7,4.15h7.5v.04h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.33,79.63h-.78v-1.03h3.69c1.49,0,2.53.94,2.53,2.48,0,1.42-.92,2.11-1.52,2.24v.02s.22.11.36.38l1.02,2.03c.12.25.31.28.6.28h.16v1.03h-.59c-.66,0-.9-.08-1.18-.64l-1.15-2.28c-.22-.4-.37-.46-.84-.46h-1.1v3.37h-1.2v-7.44.02h0Zm2.76,3.03c.91,0,1.45-.59,1.45-1.54s-.54-1.5-1.43-1.5h-1.58v3.03h1.56Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.91,80.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Zm-1.04-4.73h1.18l-1.14,1.52h-.91l.88-1.52h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.98,85.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07,0,0,.6-.78.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.98,80.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.15,82.25c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.57,82.23c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.29-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.67,80.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.74,85.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.56,81.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.08,80.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.92,80.85c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.07.89-2.07,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.35-3.24-3.18s1.31-3.18,3.26-3.18h.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.56,79.85c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.74v2.36c0,.29-.02.5-.02.5h.02c.26-.59,1.04-1.36,2.25-1.36,1.43,0,2.07.78,2.07,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.18-1.52-1.15-1.52s-1.67.62-1.92,1.5c-.08.24-.11.52-.11.8v2.84h-1.16v-7.21h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.07,82.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.64,82.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.06,80.85c1.44,0,1.95,1.03,1.95,1.03h.02v-.31c0-.36.23-.58.74-.58h1.09v1h-.49c-.17,0-.26.08-.26.26v7.21h-1.16v-2.75c0-.31.02-.53.02-.53h-.02s-.52,1.02-1.96,1.02c-1.63,0-2.66-1.29-2.66-3.18s1.14-3.18,2.74-3.18h0Zm1.91,3.17c0-1.08-.56-2.16-1.71-2.16-.96,0-1.75.79-1.75,2.17s.71,2.17,1.73,2.17c.9,0,1.74-.64,1.74-2.18h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.11,82.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.55,0,.78.23.78.74v2.88c0,.84.17,1.51,1.13,1.51,1.25,0,1.98-1.09,1.98-2.29v-2.84h1.16v4.81c0,.18.1.26.26.26h.49v1h-1.12c-.52,0-.77-.24-.77-.67v-.58h-.02c-.25.6-1.03,1.39-2.23,1.39-1.37,0-2.06-.72-2.06-2.33v-2.63h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.04,80.85c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.11,85.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.12,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.02-1.08c1.63,0,2.67,1.3,2.67,3.18s-1.18,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21h0Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.71-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.71,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.82,94.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.99,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.72,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.58h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.18-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83h-.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.42,94.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.63,95.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.86,95.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.05,97.28h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.5,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.06,95.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.64,94.85c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65v-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.29-2.67-3.18s1.14-3.18,2.75-3.18h0Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.18,94.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.25,94.85c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.08.89-2.08,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.35-3.24-3.18s1.31-3.18,3.26-3.18h.03Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.65,94.85c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.35,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.55,0,.78.23.78.74v2.88c0,.84.17,1.51,1.13,1.51,1.25,0,1.98-1.09,1.98-2.29v-2.84h1.16v4.81c0,.18.1.26.26.26h.49v1h-1.12c-.52,0-.77-.24-.77-.67v-.58h-.02c-.25.6-1.03,1.39-2.23,1.39-1.37,0-2.06-.72-2.06-2.33v-2.63h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.46,96.23c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.3-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.21,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.92,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.16,96.25c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.12,110.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.3,108.85c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.07.9-2.07,2.16.94,2.18,2.07,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.94,113.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.17,108.85c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.33,110.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.93,108.85c1.51,0,1.94.95,1.94.95h.02v-.19c0-.36.19-.61.67-.61h1.13v1h-.48c-.16,0-.26.08-.26.24v4.58c0,2-1.52,2.77-3.06,2.77-.73,0-1.48-.2-2.08-.5l.4-.94s.74.41,1.66.41c1.06,0,1.92-.47,1.92-1.69v-.41c0-.19.02-.38.02-.38h-.02c-.36.59-.92.92-1.81.92-1.68,0-2.71-1.35-2.71-3.11s.97-3.03,2.66-3.03h0Zm1.89,3.05c0-1.58-.78-2.04-1.71-2.04-1.06,0-1.66.77-1.66,2s.66,2.12,1.75,2.12c.84,0,1.62-.5,1.62-2.09h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.07,111.28h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.6,108.85c1.51,0,1.94.95,1.94.95h.02v-.19c0-.36.19-.61.67-.61h1.13v1h-.48c-.16,0-.26.08-.26.24v4.58c0,2-1.52,2.77-3.06,2.77-.73,0-1.47-.2-2.07-.5l.4-.94s.74.41,1.66.41c1.05,0,1.92-.47,1.92-1.69v-.41c0-.19.02-.38.02-.38h-.02c-.36.59-.92.92-1.81.92-1.68,0-2.71-1.35-2.71-3.11s.97-3.03,2.66-3.03h-.01Zm1.9,3.05c0-1.58-.78-2.04-1.72-2.04-1.05,0-1.65.77-1.65,2s.66,2.12,1.75,2.12c.84,0,1.62-.5,1.62-2.09h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.11,108.85c1.7,0,2.62,1.27,2.62,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.28,110.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.58h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.17-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83h-.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.98,108.85c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.42c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h0Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.14,110.25c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.7,109.93h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.32-.24-2.32-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.78,113.36s.72.9,1.83.9c.56,0,1.06-.25,1.06-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.36,19.34h2.66l2.97,5.01c.42.71.9,1.83.9,1.83h.03s-.12-1.16-.12-1.83v-5.01h2.62v10.72h-2.64l-2.98-5c-.42-.71-.9-1.83-.9-1.83h-.03s.12,1.16.12,1.83v5h-2.62v-10.72h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.81,19.16c3.24,0,5.61,2.4,5.61,5.47s-2.37,5.61-5.61,5.61-5.61-2.46-5.61-5.61,2.37-5.47,5.61-5.47Zm0,8.68c1.61,0,2.9-1.38,2.9-3.21s-1.29-3.08-2.9-3.08-2.9,1.32-2.9,3.08,1.29,3.21,2.9,3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.79,26.72s1.21,1.11,2.56,1.11c.54,0,1.12-.21,1.12-.85,0-1.28-4.83-1.23-4.83-4.53,0-1.98,1.67-3.28,3.79-3.28,2.31,0,3.45,1.21,3.45,1.21l-1.11,2.14s-1.08-.94-2.37-.94c-.54,0-1.14.24-1.14.84,0,1.35,4.83,1.11,4.83,4.5,0,1.78-1.36,3.33-3.78,3.33s-3.92-1.53-3.92-1.53l1.38-2s.02,0,.02,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.34,19.34h3.73c1.1,0,1.62.08,2.08.25,1.21.46,1.98,1.56,1.98,3.12,0,1.14-.54,2.38-1.61,2.92v.03s.15.19.41.64l2.08,3.75h-2.92l-1.91-3.62h-1.23v3.62h-2.62v-10.72h0Zm3.76,4.86c.84,0,1.37-.46,1.37-1.32,0-.81-.3-1.29-1.62-1.29h-.88v2.61h1.14,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.57,19.34h6.72v2.25h-4.09v1.95h3.27v2.25h-3.27v2.02h4.3v2.25h-6.93v-10.72h0Zm3.62-2.94h2.57l-1.77,2.25h-2.01l1.21-2.25h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.98,26.72s1.21,1.11,2.56,1.11c.54,0,1.12-.21,1.12-.85,0-1.28-4.83-1.23-4.83-4.53,0-1.98,1.67-3.28,3.79-3.28,2.31,0,3.45,1.21,3.45,1.21l-1.11,2.14s-1.08-.94-2.37-.94c-.54,0-1.14.24-1.14.84,0,1.35,4.83,1.11,4.83,4.5,0,1.78-1.36,3.33-3.78,3.33s-3.92-1.53-3.92-1.53l1.38-2s.02,0,.02,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.09,19.34h6.72v2.25h-4.09v1.95h3.27v2.25h-3.27v2.02h4.3v2.25h-6.93v-10.72h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.91,19.34h3.74c1.09,0,1.62.08,2.08.25,1.21.46,1.98,1.56,1.98,3.12,0,1.14-.54,2.38-1.6,2.92v.03s.15.19.41.64l2.08,3.75h-2.93l-1.9-3.62h-1.23v3.62h-2.62v-10.72h-.01Zm3.77,4.86c.84,0,1.36-.46,1.36-1.32,0-.81-.3-1.29-1.62-1.29h-.89v2.61h1.15Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.72,19.34h2.85l1.89,6.1c.21.67.41,1.73.41,1.73h.03s.19-1.05.4-1.73l1.92-6.1h2.8l-3.78,10.72h-2.73l-3.79-10.72h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.19,19.34h6.72v2.25h-4.09v1.95h3.27v2.25h-3.27v2.02h4.3v2.25h-6.93v-10.72h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.6,26.72s1.22,1.11,2.57,1.11c.54,0,1.12-.21,1.12-.85,0-1.28-4.83-1.23-4.83-4.53,0-1.98,1.67-3.28,3.79-3.28,2.31,0,3.45,1.21,3.45,1.21l-1.11,2.14s-1.08-.94-2.37-.94c-.54,0-1.14.24-1.14.84,0,1.35,4.83,1.11,4.83,4.5,0,1.78-1.37,3.33-3.78,3.33s-3.92-1.53-3.92-1.53l1.38-2h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie1-label3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m280.45,24.06v21h-2.25v-16.8h-3.9v-1.35c3.6-.15,4.5-2.85,4.5-2.85,0,0,1.65,0,1.65,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.6,39.21c0,3.15-2.7,6.15-7.05,6.15-4.8,0-7.05-3.15-7.05-3.15l1.5-1.5s1.8,2.55,5.55,2.55c3.15,0,4.95-1.8,4.95-4.05,0-2.13-1.89-4.05-4.95-4.05h-2.1v-2.1h2.1c2.55,0,4.05-1.5,4.05-3.75,0-1.95-1.5-3.45-4.05-3.45-3.15,0-4.8,2.4-4.8,2.4l-1.5-1.65s2.1-2.85,6.3-2.85c3.75,0,6.3,2.55,6.3,5.55,0,3.6-3.15,4.65-3.15,4.65,0,0,3.9.9,3.9,5.25Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.2,43.56l-3.45,5.4-1.35-.75,2.7-5.85s2.1,1.2,2.1,1.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.95,24.06v2.1l-9.3,18.9h-2.25l9.3-18.9h-10.95v-2.1s13.2,0,13.2,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.7,29.31c0,3.15-2.7,4.35-2.7,4.35,0,0,3.6,1.35,3.6,5.25,0,3.45-3,6.45-7.05,6.45s-7.05-3-7.05-6.45c0-3.9,3.6-5.25,3.6-5.25,0,0-2.7-1.2-2.7-4.35,0-2.85,2.7-5.55,6.15-5.55s6.15,2.7,6.15,5.55Zm-10.95,9.6c0,2.25,1.8,4.35,4.8,4.35s4.8-2.1,4.8-4.35-2.1-4.35-4.8-4.35-4.8,2.1-4.8,4.35Zm8.7-9.6c0-1.95-1.5-3.45-3.9-3.45s-3.9,1.5-3.9,3.45,1.5,3.45,3.9,3.45,3.9-1.5,3.9-3.45Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.9,39.06l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1h0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.2,36.06v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3s7.35,0,7.35,0Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m273.38,60.02h.17c.22,0,.32-.05.4-.26l2.65-7.17h1.26l2.65,7.17c.07.22.19.26.4.26h.18v1.03h-.67c-.6,0-.79-.14-.98-.7l-.64-1.74h-3.12l-.64,1.74c-.2.55-.4.7-1,.7h-.66v-1.03h0Zm5.11-2.41l-.92-2.58c-.16-.44-.34-1.19-.34-1.19h-.02s-.17.74-.32,1.19l-.92,2.58h2.53,0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.91,54.84c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.07.89-2.07,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.36-3.24-3.18s1.31-3.18,3.26-3.18h.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.31,54.84c.73,0,2.18.3,2.18,1.33v.62h-1.06v-.34c0-.43-.68-.62-1.13-.62-1.19,0-2.07.89-2.07,2.17,0,1.38,1.01,2.16,2.13,2.16s1.88-.84,1.88-.84l.5.83s-.86,1.04-2.47,1.04c-1.91,0-3.24-1.36-3.24-3.18s1.31-3.18,3.26-3.18h.02Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.09,56.24c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.5,54.84c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.72,2.17c.9,0,1.75-.64,1.75-2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.05,54.84c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.21,56.24c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.77,55.92h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.85,59.35s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.8,54.84c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.86,56.24c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.55,0,.78.23.78.74v2.88c0,.84.17,1.51,1.13,1.51,1.25,0,1.98-1.09,1.98-2.29v-2.84h1.16v4.81c0,.18.1.26.26.26h.49v1h-1.12c-.52,0-.77-.24-.77-.67v-.23c0-.19.01-.35.01-.35h-.02c-.25.6-1.03,1.39-2.23,1.39-1.37,0-2.06-.72-2.06-2.33v-2.63h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.61,55.92h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91h-.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.79,56.24c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.14,57.27h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.09,56.22c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.29-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.86,57.27h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.37,56.24c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.59,53.84c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.09,52.13h1.03l-3.05,9.43h-1.03l3.05-9.43Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.26,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.53,0,.77.23.77.67v.23c0,.19-.01.35-.01.35h.02c.29-.71,1.13-1.39,2.08-1.39,1.03,0,1.62.47,1.82,1.38h.02c.34-.73,1.18-1.38,2.16-1.38,1.37,0,2,.78,2,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.87c0-.85-.17-1.52-1.07-1.52-.84,0-1.49.73-1.7,1.56-.06.25-.1.52-.1.83v2.77h-1.16v-3.63c0-.79-.12-1.52-1.04-1.52s-1.51.74-1.74,1.61c-.06.24-.08.5-.08.78v2.77h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.59,73.27h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.01,69.84c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.33,73.27h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.49,1.03,2.49,2.37v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.07,3.66-2.07h0Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.95,70.84c1.4,0,1.87.94,1.87.94h.02s-.02-.18-.02-.41v-1.52c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.12c-.53,0-.74-.24-.74-.65,0-.18.01-.31.01-.31h-.02s-.5,1.1-1.99,1.1c-1.64,0-2.67-1.3-2.67-3.18s1.14-3.18,2.75-3.18h-.01Zm1.91,3.17c0-1.08-.56-2.16-1.73-2.16-.95,0-1.74.79-1.74,2.17s.71,2.17,1.71,2.17c.9,0,1.75-.64,1.75-2.18h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.09,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.79,70.84c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.86,75.35s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.63,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.09c.54,0,.74.23.74.61,0,.18-.01.32-.01.32h.02s.5-1.08,2.02-1.08c1.63,0,2.67,1.29,2.67,3.18s-1.17,3.18-2.76,3.18c-1.34,0-1.86-.97-1.86-.97h-.02s.02.22.02.53v2.7h-1.16v-7.21h0Zm2.84,3.96c.96,0,1.75-.79,1.75-2.17s-.71-2.17-1.72-2.17c-.9,0-1.75.64-1.75,2.18,0,1.08.59,2.16,1.72,2.16Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.88,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.1c.53,0,.78.22.78.71v.38c0,.24-.02.42-.02.42h.02c.29-.89.98-1.58,1.92-1.58.16,0,.31.02.31.02v1.15s-.16-.04-.35-.04c-.74,0-1.43.53-1.7,1.43-.11.35-.14.72-.14,1.09v2.48h-1.16v-4.81h0Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.96,70.84c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.69,71.92h-.76v-.94h.76v-.2c0-2,1.52-2.25,2.29-2.25.26,0,.44.04.44.04v1s-.12-.02-.3-.02c-.46,0-1.27.14-1.27,1.27v.18h1.44v.94h-1.44v5.13h-1.16v-5.15Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.79,70.84c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.85,75.35s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.3,75.35s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.91,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.82,70.84c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.55,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.06,72.24c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.03,70.84c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.17,69.84c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.39,69.84c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.09,70.84c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18h.01Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.22Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.16,75.35s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78h.01Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "pie1-label4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.3,304.06c0-8.85,11.25-9.15,11.25-15.15,0-2.4-1.65-4.05-4.5-4.05-3.75,0-4.5,3.6-4.5,3.6l-1.95-.9s1.05-4.8,6.45-4.8c4.05,0,6.75,2.7,6.75,6.15,0,6.45-9.15,7.5-10.95,13.05h10.95v2.1h-13.5Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.1,297.46v2.1h-2.7v4.5h-2.25v-4.5h-10.65v-2.55l10.05-13.95h2.85v14.4h2.7Zm-4.95-11.85l-8.55,11.85h8.55v-11.85Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.35,304.06c0-8.85,11.25-9.15,11.25-15.15,0-2.4-1.65-4.05-4.5-4.05-3.75,0-4.5,3.6-4.5,3.6l-1.95-.9s1.05-4.8,6.45-4.8c4.05,0,6.75,2.7,6.75,6.15,0,6.45-9.15,7.5-10.95,13.05h10.95v2.1h-13.5Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.45,302.56l-3.45,5.4-1.35-.75,2.7-5.85,2.1,1.2Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.33,304.36c-4.38,0-8.43-4.05-8.43-10.8s4.05-10.8,8.4-10.8,8.4,4.05,8.4,10.8-4.05,10.8-8.37,10.8h0Zm0-2.1c3.12,0,6.12-3,6.12-8.7s-3-8.7-6.15-8.7-6.15,3-6.15,8.7,3,8.7,6.18,8.7Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.15,289.66c0-3.9,3-6.9,7.2-6.9s7.2,3,7.2,6.9c0,2.55-1.5,4.5-1.5,4.5l-6.3,9.9h-2.25l4.95-7.8s-.87.3-2.25.3c-4.05,0-7.05-3-7.05-6.9h0Zm7.2,4.8c3,0,4.95-1.95,4.95-4.8s-1.95-4.8-4.95-4.8-4.95,1.95-4.95,4.8,1.95,4.8,4.95,4.8Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.7,298.06l-8.4-11.1v17.1h-2.25v-21h1.95l8.7,11.4,8.7-11.4h1.95v21h-2.25v-17.1l-8.4,11.1Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587,295.06v1.95h-6.9c.6,2.25,3.6,5.25,7.2,5.25s5.7-2.7,5.7-2.7l1.5,1.5s-2.58,3.3-7.2,3.3-8.4-3.6-9.6-7.35h-3v-1.95h2.7v-3h-2.7v-1.95h3c1.2-3.75,4.8-7.35,9.6-7.35s7.05,3.3,7.05,3.3l-1.5,1.5s-2.01-2.7-5.55-2.7-6.6,3-7.2,5.25h6.9v1.95h-7.35v3h7.35Z",
    style: {
      fill: "#6ac3c9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m449.78,311.5c1.14,0,3.18.48,3.18,1.83v.83h-1.1v-.48c0-.71-1.2-1.07-2.05-1.07-1.7,0-3.02,1.28-3.02,3.19s1.33,3.32,3.06,3.32,2.67-1.15,2.67-1.15l.65.86s-1.2,1.42-3.33,1.42c-2.53,0-4.29-1.95-4.29-4.45s1.82-4.31,4.25-4.31Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.23,313.9c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.01,314.98h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.25,315.3c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.39,318.41s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.01,316.33h.26v-.06c0-1.07-.4-1.45-1.34-1.45-.29,0-1,.07-1,.47v.35h-1.09v-.6c0-1,1.51-1.14,2.1-1.14,1.97,0,2.5,1.03,2.5,2.38v2.58c0,.18.1.26.26.26h.49v1h-1.09c-.54,0-.76-.26-.76-.7,0-.2.02-.36.02-.36h-.02s-.48,1.2-1.93,1.2c-1.04,0-2.06-.64-2.06-1.85,0-1.96,2.64-2.08,3.66-2.08Zm-1.34,2.99c.98,0,1.62-1.03,1.62-1.93v-.2h-.3c-.88,0-2.46.05-2.46,1.16,0,.49.37.97,1.14.97Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.51,314.98h-.79v-.94h.82v-1.67h1.14v1.67h1.45v.94h-1.45v2.78c0,1.21.84,1.37,1.28,1.37.17,0,.28-.02.28-.02v1.03s-.16.02-.41.02c-.77,0-2.31-.24-2.31-2.27v-2.91Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.74,315.3c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.66,313.9c1.81,0,3.27,1.33,3.27,3.17s-1.46,3.19-3.27,3.19-3.26-1.34-3.26-3.19,1.45-3.17,3.26-3.17Zm0,5.35c1.15,0,2.09-.91,2.09-2.18s-.94-2.16-2.09-2.16-2.08.9-2.08,2.16.94,2.18,2.08,2.18Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.39,315.3c0-.18-.1-.26-.26-.26h-.49v-1h1.12c.52,0,.77.23.77.67v.23c0,.19-.02.35-.02.35h.02c.24-.53.96-1.39,2.28-1.39,1.44,0,2.09.78,2.09,2.33v2.63c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-2.85c0-.85-.17-1.52-1.14-1.52s-1.68.61-1.92,1.49c-.08.24-.11.52-.11.82v2.84h-1.16v-4.81Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.8,318.41s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.2,315.28c-.07-.18-.18-.24-.37-.24h-.12v-1h.6c.54,0,.74.13.92.61l1.31,3.49c.12.34.22.79.22.79h.02s.1-.46.22-.79l1.29-3.49c.18-.48.4-.61.92-.61h.56v1h-.12c-.2,0-.32.06-.4.24l-1.85,4.83h-1.34l-1.87-4.83Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.02,315.3c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.72,313.9c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.94,315.3c0-.18-.1-.26-.26-.26h-.49v-1h1.14c.54,0,.77.23.77.77v4.04c0,.18.1.26.26.26h.49v1h-1.14c-.54,0-.77-.23-.77-.77v-4.04Zm.02-3.66h1.04v1.21h-1.04v-1.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.16,312.9c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.38,312.9c0-.18-.1-.26-.26-.26h-.49v-1h1.15c.54,0,.77.23.77.77v6.44c0,.18.1.26.26.26h.49v1h-1.15c-.54,0-.77-.23-.77-.77v-6.44Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.08,313.9c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.14,318.41s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.59,318.41s.72.9,1.83.9c.56,0,1.05-.25,1.05-.78,0-1.09-3.31-.97-3.31-2.93,0-1.16,1.02-1.7,2.25-1.7.73,0,1.99.25,1.99,1.18v.58h-1.04v-.3c0-.36-.54-.52-.91-.52-.68,0-1.13.24-1.13.72,0,1.15,3.31.9,3.31,2.93,0,1.08-.96,1.77-2.23,1.77-1.62,0-2.42-1.07-2.42-1.07l.6-.78Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.59,313.9c1.7,0,2.61,1.27,2.61,2.84,0,.16-.04.48-.04.48h-4.43c.07,1.3,1.01,2.03,2.09,2.03s1.78-.71,1.78-.71l.5.83s-.9.89-2.34.89c-1.92,0-3.23-1.38-3.23-3.18,0-1.93,1.32-3.18,3.05-3.18Zm1.42,2.47c-.04-1.01-.67-1.55-1.43-1.55-.89,0-1.61.54-1.79,1.55h3.21Z",
    style: {
      fill: "#015263",
      strokeWidth: 0
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2Charts1);
export default __webpack_public_path__ + "static/media/b2-charts1.c7e8542da47e52e6c7f7c443c3986bb1.svg";
export { ForwardRef as ReactComponent };